/** Bump on each release cut. Shown in a corner while debug mode is on. */
export const VERSION = 'v0.4';
